import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/views/dashboard/overview/images/notice/notice.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-a5a099e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notice-root" }
const _hoisted_2 = { class: "notice-corner" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "notice-illustration",
  src: _imports_0,
  width: "140",
  height: "140",
  alt: ""
}, null, -1))
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-close notice-close-btn__icon",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "notice-body" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "notice-header-bg" }, null, -1))
const _hoisted_9 = { class: "notice-title" }
const _hoisted_10 = { class: "notice-subtitle" }
const _hoisted_11 = { class: "notice-list" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "notice-dot",
  "aria-hidden": "true"
}, null, -1))

import { computed, onMounted, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { markVersionNoticeRead, isVersionNoticeMarkedRead } from '@/common/const/version-notice-storage'


export default /*#__PURE__*/_defineComponent({
  __name: 'version-upgrade-notice-dialog',
  setup(__props) {

const { locale } = useI18n()
const visible = ref(false)
const dialogWidth = computed(() => (locale.value === 'ja-JP' ? '545px' : '445px'))
// onMounted(() => {
//   if (!isVersionNoticeMarkedRead()) {
//     visible.value = true
//   }
// })

// watch(visible, (v) => {
//   if (!v) {
//     markVersionNoticeRead()
//   }
// })

// function closeDialog () {
//   visible.value = false
// }

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
    "custom-class": "version-upgrade-notice-dialog-custom",
    "show-close": false,
    width: dialogWidth.value,
    "append-to-body": "",
    "align-center": "",
    "close-on-click-modal": false,
    title: ''
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("button", {
            type: "button",
            class: "notice-close-btn",
            "aria-label": _ctx.$t('versionNotice.closeAria'),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeDialog && _ctx.closeDialog(...args)))
          }, _hoisted_6, 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.$t('versionNotice.title')), 1),
          _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('versionNotice.subtitle')), 1),
          _createElementVNode("ul", _hoisted_11, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
              return _createElementVNode("li", {
                key: i,
                class: "notice-list-item"
              }, [
                _hoisted_12,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t(`versionNotice.bullet${i}`)), 1)
              ])
            }), 64))
          ]),
          _createVNode(_component_el_button, {
            type: "primary",
            class: "notice-btn",
            size: "large",
            onClick: _ctx.closeDialog
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('versionNotice.gotIt')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "width"]))
}
}

})